import ApiService from '../common/api.service';

import {
  FETCH_ACCESOS,
  CLEAR_ACCESOS_ACTION,
  FETCH_SUBCONDOMINIOS,
  FETCH_VIVIENDAS,
  FETCH_DESARROLLOS,
  FETCH_IMAGE,
  FETCH_ACCESO_DETALLES,
} from './actions.type';

import {
  SET_ACCESOS,
  CLEAR_ACCESOS,
  SET_ERROR,
  FETCHING_ACCESOS,
  FETCHED_ACCESOS,
  CANCELLED_ACCESO,
  CANCELLING_ACCESO,
  RESET_REVOKE_SUBMIT,
  SENT_CANCEL_ACCESO,
  FETCHING_VIVIENDAS,
  SET_VIVIENDAS,
  FETCHED_VIVIENDAS,
  SET_SUBCONDOMINIOS,
  SET_DESARROLLOS,
  SET_ACCESO_DETALLES,
  CLEAR_ACCESOS_DETALLES,
  FETCHING_ACCESO_DETALLES,
  FETCHED_ACCESO_DETALLES,
} from './mutations.type';


/* eslint-disable no-param-reassign */
/* eslint-disable no-shadow */

const state = {
  accesos_list: [],
  loading_accesos: false,
  getted_detalles: false,
  sending_revoke: false,
  revoke_sent: false,
  alert: false,
  alertMessage: '',
  alertType: 'success',
  condominios: [],
  subcondominios: [],
  viviendas: [],
  viviendasIsLoading: false,
  accesos_detalles: [],
  accesos_total: 0,
};

const getters = {
  getted_detalles(state) {
    return state.getted_detalles;
  },
  accesos_detalles(state) {
    return state.accesos_detalles;
  },
  accesos_list(state) {
    return state.accesos_list;
  },
  loading_accesos(state) {
    return state.loading_accesos;
  },
  sending_revoke(state) {
    return state.sending_revoke;
  },
  revoke_sent(state) {
    return state.revoke_sent;
  },
  revoke_alert(state) {
    return state.alert;
  },
  revoke_alertMessage(state) {
    return state.alertMessage;
  },
  revoke_alertType(state) {
    return state.alertType;
  },
  condominios(state) {
    return state.condominios;
  },
  subcondominios(state) {
    return state.subcondominios;
  },
  viviendas(state) {
    return state.viviendas;
  },
  viviendasIsLoading(state) {
    return state.viviendasIsLoading;
  },
  accesos_total(state) {
    return state.accesos_total;
  },
};

const actions = {
  [FETCH_IMAGE](context, image, originalContext) {
    return new Promise((resolve) => {
      ApiService.setHeader();
      ApiService.queryBlob(`accesos/obra_access_image/${image}`)
        .then(({ data }) => {
          const buffer = Buffer.from(data, 'base64').toString('base64');
          resolve(buffer);
        })
        .catch(() => {
        });
    });
  },
  [FETCH_ACCESO_DETALLES](context, accesoId) {
    return new Promise((resolve) => {
      context.commit(FETCHING_ACCESO_DETALLES);
      ApiService.setHeader();
      ApiService.query(`accesos/access_detail/${accesoId}`)
        .then(({ data }) => {
          context.commit(SET_ACCESO_DETALLES, data);
          context.commit(FETCHED_ACCESO_DETALLES);
          resolve(data);
        })
        .catch(({ response }) => {
          context.commit(SET_ERROR, [response.data.message]);
          context.commit(FETCHED_ACCESOS);
        });
    });
  },
  [FETCH_ACCESOS](context, data) {
    return new Promise((resolve) => {
      context.commit(FETCHING_ACCESOS);
      ApiService.setHeader();
      ApiService.post('accesos/obras_historic_list', data)
        .then(({ data }) => {
          context.commit(SET_ACCESOS, data);
          context.commit(FETCHED_ACCESOS);
          resolve(data);
        })
        .catch(({ response }) => {
          context.commit(SET_ERROR, [response.data.message]);
          context.commit(FETCHED_ACCESOS);
        });
    });
  },
  [CLEAR_ACCESOS_ACTION](context) {
    context.commit(CLEAR_ACCESOS);
  },
  [FETCH_VIVIENDAS](context) {
    return new Promise((resolve) => {
      ApiService.setHeader();
      context.commit(FETCHING_VIVIENDAS);
      ApiService.query('accesos/viviendas')
        .then(({ data }) => {
          context.commit(SET_VIVIENDAS, data);
          context.commit(FETCHED_VIVIENDAS);
          resolve(data);
        })
        .catch(({ response }) => {
          context.commit(SET_ERROR, [response.data.message]);
          context.commit(FETCHED_VIVIENDAS);
        });
    });
  },
  [FETCH_SUBCONDOMINIOS](context) {
    return new Promise((resolve) => {
      ApiService.setHeader();
      ApiService.query('accesos/subcondominios')
        .then(({ data }) => {
          context.commit(SET_SUBCONDOMINIOS, data);
          resolve(data);
        })
        .catch(({ response }) => {
          context.commit(SET_ERROR, [response.data.message]);
        });
    });
  },
  [FETCH_DESARROLLOS](context) {
    return new Promise((resolve) => {
      ApiService.setHeader();
      ApiService.query('accesos/desarrollos')
        .then(({ data }) => {
          context.commit(SET_DESARROLLOS, data);
          resolve(data);
        })
        .catch(({ response }) => {
          context.commit(SET_ERROR, [response.data.message]);
        });
    });
  },
};

const mutations = {
  [FETCHING_ACCESO_DETALLES](state) {
    state.getted_detalles = false;
  },
  [FETCHED_ACCESO_DETALLES](state) {
    state.getted_detalles = true;
  },
  [CLEAR_ACCESOS_DETALLES](state) {
    state.accesos_detalles = [];
    state.getted_detalles = false;
  },
  [SET_ACCESO_DETALLES](state, data) {
    state.accesos_detalles = data.detalle;
  },
  [SET_ACCESOS](state, data) {
    state.accesos_list = data.accesos;
    state.accesos_total = data.total;
  },
  [FETCHING_VIVIENDAS](state) {
    state.viviendasIsLoading = true;
  },
  [FETCHED_VIVIENDAS](state) {
    state.viviendasIsLoading = false;
  },
  [SET_VIVIENDAS](state, data) {
    state.viviendas = data.viviendas;
  },
  [CLEAR_ACCESOS](state) {
    state.accesos_list = [];
    state.total = 0;
  },
  [FETCHING_ACCESOS](state) {
    state.loading_accesos = true;
  },
  [FETCHED_ACCESOS](state) {
    state.loading_accesos = false;
  },
  [CANCELLING_ACCESO](state) {
    state.sending_revoke = true;
  },
  [SENT_CANCEL_ACCESO](state) {
    state.sending_revoke = false;
  },
  [CANCELLED_ACCESO](state) {
    state.sending_revoke = false;
    state.revoke_sent = true;
  },
  [RESET_REVOKE_SUBMIT](state) {
    state.sending_revoke = false;
    state.revoke_sent = false;
  },
  [SET_ERROR](state, data) {
    state.alert = true;
    state.alertMessage = data;
    state.alertType = 'error';
  },
};

export default {
  namespaced: true,
  state,
  actions,
  mutations,
  getters,
};
